import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { PlanService } from "../../../../services/plan.service";
import { CommonService } from "../../../../services/common.service";
import { CartService } from "../../../../services/cart.service";
import { AnalyticsService } from "../../../../services/analytics.service";

@Component({
  selector: "page-cart-add",
  templateUrl: "./add.component.html",
})
export class PageCartAddComponent implements OnInit {
  public planCode: any;
  public thePlan: any = {};
  public detailError: any = null;

  public cartItem: any = {
    plan: {},
    planCode: "",
    targetDay: "",
    passenger: {
      adult: {
        men: 0,
        women: 0,
        total: 0,
      },
      children: {
        men: 0,
        women: 0,
        total: 0,
      },
    },
    departure: -1,
    destination: -1,
    totalPrice: 0,
    keioFareData: {},
    koboFareData: {},
  };

  public isUpdating = false;

  public activeCartItemIndex = 0;

  public activatedStation: any = {};

  public bestPriceList: any = {};

  /* CALENDAR */
  /**
   * [F-12] viewingDate はテンプレート(add.component.html)で参照されていないデッドプロパティ。
   * テンプレートのカレンダーは moment().format('YYYY-MM-DD') をハードコードしている。
   * initPlanData()で過去日付補正時の viewingDate 更新もコメントアウト済み（204行目）。
   * 将来カレンダーの表示月をtargetDayに連動させる場合はこのプロパティを復活させ、
   * テンプレートの plan-calendar の [targetDay] バインドを viewingDate に差し替えること。
   */
  public viewingDate: string;

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  public moment: any;
  public _: any;
  public $: any;

  constructor(
    public location: Location,
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public planService: PlanService,
    public cartService: CartService,
    private analyticsService: AnalyticsService
  ) {
    this._ = this.commonService.getLodash();
    this.moment = this.commonService.getMoment();
    this.$ = this.commonService.getJQuery();
  }

  async ngOnInit() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET PLAN DATA */
    this.planCode = this.activatedRoute.snapshot.paramMap.get("planCode");
    this.cartItem.planCode = this.planCode;

    /* CHECK targetDay */
    let targetDay = this.activatedRoute.snapshot.queryParams.targetDay;
    if (
      targetDay &&
      this.moment(targetDay, "YYYY-MM-DD", true).isValid() === true
    ) {
      this.cartItem.targetDay = targetDay;
    } else {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanDetailNoParam,
        [this.planCode]
      );
    }
    /* END */

    /* SET DATE FOR CALENDAR */
    this.viewingDate = this.cartItem.targetDay;

    let itemIndex = this.activatedRoute.snapshot.queryParams.item;

    /* GET CART DATA */
    let alreadyInCart = false;
    let cartData: any = this.cartService.getCartData();

    if (cartData) {
      if (cartData[itemIndex]) {
        this.isUpdating = true;
        alreadyInCart = true;
        this.activeCartItemIndex = itemIndex;
        this.thePlan = cartData[itemIndex].plan;
        this.cartItem = cartData[itemIndex];

        if (Object.keys(cartData[itemIndex].koboFareData).length > 0) {
          this.getKoboPrice();
        }
      }
    }

    if (!alreadyInCart) {
      /* LOAD PLAN DETAILS */
      await this.loadPlanDetails();
    }

    /* INIT PLAN DATA */
    await this.initPlanData();

    /* SET PAGE TITLE */
    this.commonService.setTitle(
      `カート: ${this.cartItem.plan.course_name} | バスブックマーク`
    );

    /* HIDE LOADER */
    this.commonService.hidePageLoader();

    /* SET VIEWED */
    this.planService.setPlanViewed(this.thePlan);
  }

  async loadPlanDetails() {
    this.thePlan = await this.planService.getPlanDetail(
      this.planCode,
      this.cartItem.targetDay,
      'cart_add'
    );
    /* IF IT'S KEIO BUS */
    if (this.isKeioBus()) {
      this.cartItem.keioFareData = await this.planService.getKeioFareData({
        lineID: this.thePlan.keio_data.line_id,
        wayID: this.thePlan.keio_data.way_id,
        date: this.cartItem.targetDay.replace(/-/g, ""),
        planName: this.thePlan.keio_data.plan_code,
      });
    }

    /* CHECK MEN & WOMEN ONLY */
    this.planService.checkIfHasMenOrWomenOnly(this.thePlan);

    this.cartItem.plan = this.thePlan;
  }

  async getKoboPrice() {
    const departureCode =
      this.cartItem.plan.station_list[this.cartItem.departure].station_code;
    const destinationId =
      this.cartItem.plan.station_list[this.cartItem.destination].station_id;

    this.commonService.showPageLoader("読み込み中...");

    const data = await this.planService.getKoboFareData({
      plan_code: this.planCode,
      target_day: this.cartItem.targetDay,
      dpt_station_code: departureCode,
      dst_station_code: destinationId,
    });

    this.cartItem.koboFareData = data;

    if (Object.keys(data).length > 0) {
      if (data.stock.stock_count > 0) {
        this.cartItem.plan.price = data.price.price;
        this.cartItem.plan.price_child = data.price.price_child;
      } else {
        this.detailError =
          "便は満席です。別の出発地と目的地を選択してください。";
      }

      this.commonService.hidePageLoader();
      this.calculateTotal();
    } else {
      this.detailError =
        "乗車地と降車地が対応していません。もう一度降車地を選んでください。";
      this.commonService.hidePageLoader();
    }

    this.commonService.hidePageLoader();
  }

  async initPlanData() {
    /* SAVE LAST STATIONS */
    this.tempData.lastDeparture = this.cartItem.departure;
    this.tempData.lastDestination = this.cartItem.destination;

    /* CHECK IF TARGET DAY IS VALID */
    /* UPDATED TO SHOWING SOLD OUT MESSAGE */
    if (!this.cartItem.plan.calendar.hasOwnProperty(this.cartItem.targetDay)) {
      // let today = Object.keys(this.cartItem.plan.calendar)[0]; /* GET FIRST DAY OF CALENDAR */
      // this.viewingDate = today;
      // this.cartItem.targetDay = today;
      // this.location.replaceState(`${this.commonService.routePaths.pageCartAddNoParam}${this.thePlan.plan_code}?targetDay=${this.cartItem.targetDay}`);

      /* GET DIVISION DATA */
      this.tempData.divisionData = await this.planService.getDivisions();
      /* END */
    }

    /* CONVERT CALENDAR PRICE TO BEST PRICE FOR CALENDAR */
    this.bestPriceList = this.planService.getCalendarPrices(
      this.thePlan.calendar
    );

    /* UPDATE PLAN PRICE BY TARGET DAY */
    this.updatePlanPrices();

    /* CHECK BUS WITH AGE LIMIT */
    this.thePlan.isBusWithAgeLimit =
      this.commonService.appConfig.reservation.planAgeLimit.hasOwnProperty(
        this.thePlan.office_code
      )
        ? true
        : false;
    this.cartItem.plan = this.thePlan;
  }

  addToCart() {
    this.calculateAlightingDay();
    /* SET CREATED TIME */
    this.cartItem.createdAt = new Date().getTime();
    /* CHECK KEIO RULES */
    if (!this.checkKeioPassengerLimit()) {
      return;
    }

    this.cartService.addToCart(this.cartItem);
    this.analyticsService.addToCart(this.cartItem, this.tempData.divisionData);
    return this.commonService.redirectToRoute(
      this.commonService.routePaths.pageCartIndex
    );
  }

  updateCart() {
    this.calculateAlightingDay();
    /* CHECK KEIO RULES */
    if (!this.checkKeioPassengerLimit()) {
      return;
    }
    this.cartService.updateCart(this.cartItem, this.activeCartItemIndex);
    return this.commonService.redirectToRoute(
      this.commonService.routePaths.pageCartIndex
    );
  }

  calculateAlightingDay() {
    if (this.cartItem.plan.station_list) {
      let firstTime =
        this.cartItem.plan.station_list[this.cartItem.departure].station_time;
      firstTime = parseInt(firstTime.replace(":", ""));

      let lastTime =
        this.cartItem.plan.station_list[this.cartItem.destination].station_time;
      lastTime = parseInt(lastTime.replace(":", ""));

      if (firstTime > lastTime) {
        this.cartItem.alightingDay = this.moment(this.cartItem.targetDay)
          .add(1, "days")
          .format("YYYY-MM-DD");
      } else {
        this.cartItem.alightingDay = this.cartItem.targetDay;
      }
    }
  }

  updatePlanPrices() {
    let priceData: any;
    if (this.cartItem.plan.calendar.hasOwnProperty(this.cartItem.targetDay)) {
      priceData = this.cartItem.plan.calendar[this.cartItem.targetDay];
    } else {
      /* NOT FOUND IN CALENDAR */
      /* SET TO THE FIRST DATE OF CALENDAR */
      let today = this.moment().format("YYYY-MM-DD");
      priceData = this.cartItem.plan.calendar[today];
      /* this.cartItem.targetDay = today; */
      /* SHOW SOLD OUT MESSAGE */
      this.cartItem.plan.soldOut = true;
      this.$("#warningModal").modal();

      /* REDIRECT TO SEARCH PAGE WHEN MODAL CLOSING */
      this.$("#warningModal").on("hide.bs.modal", () => {
        try {
          this.commonService.redirectToRoute(
            `${this.commonService.routePaths.pagePlanListNoParam}/${
              this.tempData.divisionData.division_map.id_bb[
                this.cartItem.plan.dpt_coty_id
              ].slug
            }/${this.cartItem.targetDay.replace(/-/g, "")}`
          );
        } catch (err) {
          this.commonService.redirectToRoute(
            `${
              this.commonService.routePaths.pagePlanListNoParam
            }/${this.cartItem.targetDay.replace(/-/g, "")}`
          );
        }
      });

      return;
    }

    this.cartItem.plan.price = priceData.price;
    this.cartItem.plan.price_child = priceData.price_child;
    this.cartItem.plan.child_price = priceData.price_child;
    this.cartItem.plan.enable_seat = priceData.last_seat;

    /* RESET CHILDREN SEATS */
    if (priceData.price_child <= 0) {
      this.cartItem.passenger.children.men = 0;
      this.cartItem.passenger.children.women = 0;
    }

    /* RE-COUNT TOTAL PRICE */
    this.calculateTotal();

    /* UPDATE ROUTE */
    this.updateRoute();
  }

  peopleChange() {
    this.detailError = null;
    if (
      this.isKoboBus() &&
      this.cartItem.departure != -1 &&
      this.cartItem.destination != -1
    ) {
      this.getKoboPrice();
    }
    this.calculateTotal();
  }

  setStation(type = "", index = -1) {
    switch (type) {
      case "departure":
        this.cartItem.departure = index;
        break;

      case "destination":
        this.cartItem.destination = index;
        break;
    }
    this.detailError = null;
    /* SAVE LAST CHANGES */
    this.tempData.lastDeparture = this.cartItem.departure;
    this.tempData.lastDestination = this.cartItem.destination;

    /* CHECK IF IT'S KEIO BUS */
    if (this.isKeioBus()) {
      if (this.cartItem.departure != -1 && this.cartItem.destination != -1) {
        this.calculateTotal();
      }
    }

    if (this.isKoboBus()) {
      if (this.cartItem.departure != -1 && this.cartItem.destination != -1) {
        this.getKoboPrice();
      }
    }
  }

  calculateTotal() {
    if (this.planService.calculateTotal(this.cartItem) === false) {
      /* TO DO */
      if (
        this.tempData.lastDeparture != -1 &&
        this.tempData.lastDestination != -1
      ) {
        this.tempData.warningMessage = this.commonService.translate(
          "cart.warning.unavailableBus",
          {
            departure:
              this.cartItem.plan.station_list[this.tempData.lastDeparture]
                .station_name_full,
            destination:
              this.cartItem.plan.station_list[this.tempData.lastDestination]
                .station_name_full,
          }
        );
        this.$("#commonWarningModal").modal();
      }
    }
  }

  checkKeioPassengerLimit() {
    if (this.isKeioBus()) {
      if (
        this.commonService.appConfig.plan.keio.passengerLimit <
        this.cartItem.passenger.adult.total +
          this.cartItem.passenger.children.total
      ) {
        this.tempData.warningMessage = this.commonService.translate(
          "cart.warning.maxPassengerLimit",
          {
            numberLimit: this.commonService.appConfig.plan.keio.passengerLimit,
          }
        );
        this.$("#commonWarningModal").modal();

        return false;
      }
    }

    return true;
  }

  isKeioBus() {
    return (
      this.thePlan.source_id == this.commonService.appConfig.plan.sources.keio
    );
  }

  isKoboBus() {
    return (
      this.thePlan.source_id === this.commonService.appConfig.plan.sources.kobo
    );
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  /* BELONGS TO CALENDAR */
  async onChooseDay(data: any) {
    if (this.bestPriceList.hasOwnProperty(data.date)) {
      this.cartItem.targetDay = this.moment(data.date).format("YYYY-MM-DD");
      /* UPDATE PLAN PRICE BY TARGET DAY */
      this.updatePlanPrices();
      /* UPDATE ROUTE */
      this.updateRoute();

      /* CHECK SEAT AVAILABLE */
      /* SHOW LOADER */
      this.commonService.showPageLoader("読み込み中...");

      /* LOAD PLAN DETAILS */
      await this.loadPlanDetails();

      /* INIT PLAN DATA */
      await this.initPlanData();

      if (this.cartItem.plan.seat_available == 0) {
        /* SCROLL TO TOP */
        this.commonService.scrollToTop();
      }

      /* HIDE LOADER */
      this.commonService.hidePageLoader();
    }
  }

  updateRoute() {
    if (!this.isUpdating) {
      this.location.replaceState(
        `${this.commonService.routePaths.pageCartAddNoParam}${this.thePlan.plan_code}?targetDay=${this.cartItem.targetDay}`
      );
    }
  }

  /**
   * [F-9] 座席数セレクトボックスの選択肢数を返す（0名〜N名）
   *
   * 修正前の問題:
   *   enable_seat がAPIレスポンスの文字列("5"等)の場合、
   *   "5" + 1 → "51" となり [].constructor("51") で RangeError が発生。
   *   enable_seat が undefined の場合は 10 > undefined → false で10が返るため
   *   一見動作するが、意図しない残席数表示になる可能性がある。
   *
   * 修正内容:
   *   Number()で明示的に数値変換し、NaN/undefined/null を 0 として扱う。
   *   テンプレート側で [].constructor(getSeatCount()) として使われるため、
   *   必ず正の整数を返す必要がある（0以下や非数値だとRangeError）。
   */
  getSeatCount() {
    const seat = Number(this.cartItem.plan.enable_seat) || 0;
    if (10 > seat) {
      return seat + 1;
    } else {
      return 10;
    }
  }
}
